import React from 'react'
import { Link } from 'react-router-dom'
import bgImage from '../assets/bgImage.jpg'

const campaigns = [
  {
    icon: '🩺',
    title: 'Free Medical Camp Drive',
    tag: 'Health',
    date: 'Ongoing',
    desc: 'Organising free medical camps across all 27 districts of Haryana. Providing consultations, medicines, and health check-ups to underserved communities who cannot afford private healthcare.',
    color: '#E8670A',
  },
  {
    icon: '📚',
    title: 'Back to School Initiative',
    tag: 'Education',
    date: 'Ongoing',
    desc: 'Ensuring every child in Haryana has access to quality education. Providing free books, stationery, uniforms, and school admission support to children from economically weaker sections.',
    color: '#1A2F5E',
  },
  {
    icon: '🌾',
    title: 'Disaster Relief & Rehabilitation',
    tag: 'Welfare',
    date: 'Active',
    desc: 'Swift relief operations during floods, droughts, and other natural disasters. Distributing food packets, clothing, and essential supplies to affected families across the state.',
    color: '#E8670A',
  },
  {
    icon: '🤝',
    title: 'Skill Haryana – Vocational Training',
    tag: 'Self-Reliance',
    date: 'Ongoing',
    desc: 'Empowering youth and women with vocational skills such as tailoring, computer literacy, beauty care, and carpentry — enabling them to earn sustainable livelihoods.',
    color: '#1A2F5E',
  },
  {
    icon: '🧓',
    title: 'Vriddha Seva – Elder Care Programme',
    tag: 'Social Welfare',
    date: 'Ongoing',
    desc: 'Dedicated care and support for the elderly and destitute through our Sewa Shri Ashram. Providing shelter, meals, medical care, and companionship to seniors who have no support.',
    color: '#E8670A',
  },
  {
    icon: '🌿',
    title: 'Paryavaran Sewa – Green Haryana',
    tag: 'Environment',
    date: 'Seasonal',
    desc: 'Tree plantation drives, cleanliness campaigns, and environmental awareness programs across villages and cities of Haryana to build a greener, healthier state for future generations.',
    color: '#1A2F5E',
  },
]

export default function Campaign() {
  return (
    <div>
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-4">
          <h1>Campaign</h1>
          <p className="breadcrumb">Home › Campaign</p>
        </div>
      </div>

      {/* Intro */}
      <section className="py-16" style={{background:'white'}}>
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="section-tag" style={{justifyContent:'center'}}>Active Campaigns</div>
          <h2 className="mb-4" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(26px,4vw,42px)',fontWeight:700,color:'var(--navy)'}}>
            Our Ongoing Campaigns
          </h2>
          <p className="mx-auto text-base leading-relaxed" style={{color:'var(--muted)',maxWidth:'600px'}}>
            Sewa Bharti Haryana runs several impactful campaigns year-round to address the most pressing needs of the community. Join us in making a difference.
          </p>
        </div>
      </section>

      {/* Campaign Cards */}
      <section className="pb-20" style={{background:'white'}}>
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {campaigns.map((c, i) => (
            <div key={i} className="rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-2 group"
              style={{border:'1px solid rgba(0,0,0,0.07)',boxShadow:'0 2px 12px rgba(13,27,62,0.05)'}}>
              {/* Card top color bar */}
              <div className="h-1.5" style={{background: i % 2 === 0 ? 'linear-gradient(90deg,var(--saffron),var(--saffron-light))' : 'linear-gradient(90deg,var(--navy),var(--navy-mid))'}}/>
              <div className="p-7">
                <div className="flex items-start justify-between mb-5">
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-3xl flex-shrink-0"
                    style={{background: i % 2 === 0 ? 'var(--saffron-pale)' : 'rgba(13,27,62,0.06)'}}>
                    {c.icon}
                  </div>
                  <div className="flex flex-col items-end gap-1.5">
                    <span className="text-xs font-semibold px-3 py-1 rounded-full" style={{background:'var(--saffron-pale)',color:'var(--saffron)'}}>
                      {c.tag}
                    </span>
                    <span className="text-xs" style={{color:'var(--muted)'}}>{c.date}</span>
                  </div>
                </div>
                <h3 className="font-bold text-base mb-3 leading-snug" style={{color:'var(--navy)',fontFamily:'Playfair Display,serif'}}>{c.title}</h3>
                <p className="text-sm leading-relaxed mb-5" style={{color:'var(--muted)'}}>{c.desc}</p>
                <Link to="/get-involved"
                  className="inline-flex items-center gap-2 text-sm font-semibold transition-colors"
                  style={{color:'var(--saffron)'}}>
                  Get Involved
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-20 relative overflow-hidden" style={{background:`url(${bgImage}) center/cover fixed`}}>
        <div className="absolute inset-0" style={{background:'rgba(13,27,62,0.87)'}}/>
        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <div className="text-4xl mb-4">🙏</div>
          <h2 className="text-white font-bold mb-4" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(26px,4vw,40px)'}}>
            Be Part of the Change
          </h2>
          <p className="mb-8 leading-relaxed" style={{color:'rgba(255,255,255,0.6)'}}>
            Every campaign needs hands, hearts, and resources. Whether you volunteer your time, donate funds, or spread the word — your support powers our mission.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link to="/get-involved"
              className="inline-flex items-center gap-2 text-white px-7 py-3.5 rounded-full font-semibold text-sm"
              style={{background:'var(--saffron)'}}>
              Volunteer With Us
            </Link>
            <Link to="/donate"
              className="inline-flex items-center gap-2 text-white px-7 py-3.5 rounded-full font-semibold text-sm"
              style={{border:'1.5px solid rgba(255,255,255,0.35)'}}>
              Donate Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
